/* eslint-disable @typescript-eslint/no-explicit-any */
import type {
  patchValues,
  value,
  valueDetailsBudget,
  valueSource,
} from "../types/financeAccount";
import api from "./api";

const handleCatch = (error: any) => {
  if (error.code === "DATABASE_ERROR" && error?.details?.length > 0) {
    error.message = error?.details[0];
  }

  throw error;
};

export const getFinanceAccount = async (
  dataFilter: { tipo: string; status: string },
  pageParam: number,
  search?: string,
) => {
  try {
    const res = await api.get(`/financeAccount`, {
      params: { ...dataFilter, pageParam, search },
    });

    return res.data.data;
  } catch (error: any) {
    throw (
      error.response?.data?.message ||
      error?.message ||
      error?.data ||
      "Erro desconhecido!"
    );
  }
};

export const postAccount = async ({ ativo, nome, tipo }: value) => {
  try {
    const response = await api.post(`/financeAccount/postAccount`, {
      ativo,
      nome,
      tipo,
    });

    return response.data;
  } catch (error: any) {
    if (error.code === "DATABASE_ERROR") {
      error.message =
        error.details?.length > 0
          ? error.details[0]
          : "Erro criar nova conta financeira";
    }
    if (error.code === "INTERNAL_SERVER_ERROR") {
      error.message =
        error.details?.length > 0 ? error.details[0] : "Erro desconhecido!";
    }

    throw error;
  }
};

export const getAccount = async (uid: string) => {
  try {
    const res = await api.get(`/financeAccount/getAccount`, {
      params: { uid },
    });

    return res.data.data;
  } catch (error: any) {
    if (error.code === "DATABASE_ERROR") {
      error.message =
        error.details?.length > 0 ? error.details[0] : "Erro ao carregar conta";
    }
    if (error.code === "INTERNAL_SERVER_ERROR") {
      error.message =
        error.details?.length > 0 ? error.details[0] : "Erro desconhecido!";
    }

    throw error;
  }
};

export const patchAccount = async (data: patchValues) => {
  try {
    const response = await api.patch(`/financeAccount/patchAccount`, {
      ...data,
    });

    return response.data;
  } catch (error: any) {
    if (error.code === "DATABASE_ERROR") {
      error.message =
        error.details?.length > 0
          ? error.details[0]
          : "Erro criar nova conta financeira";
    }
    if (error.code === "INTERNAL_SERVER_ERROR") {
      error.message =
        error.details?.length > 0 ? error.details[0] : "Erro desconhecido!";
    }

    throw error;
  }
};

export const deleteAccount = async (uid_conta_financeira: string) => {
  try {
    const res = await api.delete(`/financeAccount/deleteAccount`, {
      params: { uid_conta_financeira },
    });

    return res.data;
  } catch (error: any) {
    if (error.code === "DATABASE_ERROR") {
      error.message =
        error.details?.length > 0
          ? error.details[0]
          : "Erro ao deletar conta financeira";
    }
    if (error.code === "INTERNAL_SERVER_ERROR") {
      error.message =
        error.details?.length > 0 ? error.details[0] : "Erro desconhecido!";
    }

    throw error;
  }
};

export const getSourceResources = async (
  pageParam: number,
  search?: string,
) => {
  try {
    const res = await api.get(`/financeAccount/getSourceResources`, {
      params: { pageParam, search },
    });

    return res.data;
  } catch (error: any) {
    throw (
      error.response?.data?.message ||
      error?.message ||
      error?.data ||
      "Erro desconhecido!"
    );
  }
};

export const getSource = async (uid: string) => {
  try {
    const res = await api.get(`/financeAccount/getSource`, {
      params: { uid },
    });

    return res.data;
  } catch (error: any) {
    throw (
      error.response?.data?.message ||
      error?.message ||
      error?.data ||
      "Erro desconhecido!"
    );
  }
};

export const postSource = async (data: valueSource) => {
  try {
    const response = await api.post(`/financeAccount/postSource`, {
      ...data,
    });

    return response.data;
  } catch (error: any) {
    throw (
      error.response?.data?.message ||
      error?.message ||
      error?.data ||
      "Erro desconhecido!"
    );
  }
};

export const patchSource = async (
  data: valueSource,
  uid_fonte_pagadora: string,
) => {
  try {
    const response = await api.patch(`/financeAccount/patchSource`, {
      ...data,
      uid_fonte_pagadora,
    });

    return response.data;
  } catch (error: any) {
    throw (
      error.response?.data?.message ||
      error?.message ||
      error?.data ||
      "Erro desconhecido!"
    );
  }
};

export const deleteSource = async (uid_fonte_pagadora: string) => {
  try {
    const res = await api.delete(`/financeAccount/deleteSource`, {
      params: { uid_fonte_pagadora },
    });

    return res.data;
  } catch (error: any) {
    throw (
      error.response?.data?.message ||
      error?.message ||
      error?.data ||
      "Erro desconhecido!"
    );
  }
};

export const getFinanceAccountOptions = async () => {
  try {
    const res = await api.get(`/financeAccount/getFinanceAccountOptions`);

    return res.data.data;
  } catch (error: any) {
    throw (
      error.response?.data?.message ||
      error?.message ||
      error?.data ||
      "Erro desconhecido!"
    );
  }
};

export const getBudgetsPlans = async (
  pageParam: number,
  orderTable: {
    ano?: "ASC" | "DESC";
    nome?: "ASC" | "DESC";
    status?: "ASC" | "DESC";
  },
  search?: string,
) => {
  try {
    const res = await api.get(`/financeAccount/getBudgetsPlans`, {
      params: { pageParam, search, orderTable },
    });

    return res.data;
  } catch (error: any) {
    handleCatch(error);
  }
};

export const getSourceOptions = async () => {
  try {
    const res = await api.get(`/financeAccount/getSourceOptions`);

    return res.data;
  } catch (error: any) {
    handleCatch(error);
  }
};

export const patchBudgetPlan = async ({
  ano,
  uid_fonte_pagadora,
  uid_plano_orcamentario,
}: {
  ano: string;
  uid_fonte_pagadora: string;
  uid_plano_orcamentario?: string;
}) => {
  try {
    const response = await api.patch(`/financeAccount/patchBudgetPlan`, {
      ano,
      uid_fonte_pagadora,
      uid_plano_orcamentario,
    });

    return response.data;
  } catch (error: any) {
    handleCatch(error);
  }
};

export const postBudgetPlan = async ({
  ano,
  uid_fonte_pagadora,
}: {
  ano: string;
  uid_fonte_pagadora: string;
}) => {
  try {
    const response = await api.post(`/financeAccount/postBudgetPlan`, {
      ano,
      uid_fonte_pagadora,
    });

    return response.data;
  } catch (error: any) {
    handleCatch(error);
  }
};

export const deleteBudgetsPlans = async (uid_plano_orcamentario: string) => {
  try {
    const res = await api.delete(`/financeAccount/deleteBudgetsPlans`, {
      params: { uid_plano_orcamentario },
    });

    return res.data;
  } catch (error: any) {
    handleCatch(error);
  }
};

export const getBudgetPlan = async (uid_plano_orcamentario: string) => {
  try {
    const res = await api.get(`/financeAccount/getBudgetPlan`, {
      params: { uid_plano_orcamentario },
    });

    return res.data;
  } catch (error: any) {
    handleCatch(error);
  }
};

export const getBudgetPlanDetails = async (
  uid_plano_orcamentario: string,
  pageParam: number,
) => {
  try {
    const res = await api.get(`/financeAccount/getBudgetPlanDetails`, {
      params: { uid_plano_orcamentario, pageParam },
    });

    return res.data;
  } catch (error: any) {
    handleCatch(error);
  }
};

export const getComponentOptions = async () => {
  try {
    const res = await api.get(`/financeAccount/getComponentOptions`);

    return res.data;
  } catch (error: any) {
    handleCatch(error);
  }
};

export const getComponent = async (
  uid_plano_orcamentario_valor: string,
  uid_plano_orcamentario_componente: string,
) => {
  try {
    const res = await api.get(`/financeAccount/getComponent`, {
      params: {
        uid_plano_orcamentario_valor,
        uid_plano_orcamentario_componente,
      },
    });

    return res.data;
  } catch (error: any) {
    handleCatch(error);
  }
};

export const postBudgetPlanDetails = async (data: valueDetailsBudget) => {
  try {
    const res = await api.post(`/financeAccount/postBudgetPlanDetails`, data);

    return res.data;
  } catch (error: any) {
    handleCatch(error);
  }
};

export const patchBudgetPlanDetails = async (
  data: valueDetailsBudget & { uid_plano_orcamentario_valor: string },
) => {
  try {
    const res = await api.patch(`/financeAccount/patchBudgetPlanDetails`, data);

    return res.data;
  } catch (error: any) {
    handleCatch(error);
  }
};

export const deleteBudgetPlanDetails = async (
  uid_plano_orcamentario_valor: string,
) => {
  try {
    const res = await api.delete(`/financeAccount/deleteBudgetPlanDetails`, {
      params: { uid_plano_orcamentario_valor },
    });

    return res.data;
  } catch (error: any) {
    handleCatch(error);
  }
};

export const getBudgetComponents = async (
  pageParam: number,
  orderTable: {
    nome?: "ASC" | "DESC";
    natureza?: "ASC" | "DESC";
    tipo_vinculo?: "ASC" | "DESC";
    ativo?: "ASC" | "DESC";
    observacao?: "ASC" | "DESC";
  },
  search?: string,
) => {
  try {
    const res = await api.get(`/financeAccount/getBudgetComponents`, {
      params: { pageParam, orderTable, search },
    });

    return res.data?.data;
  } catch (error: any) {
    handleCatch(error);
  }
};

export const deleteBudgetComponent = async (
  uid_plano_orcamentario_componente: string,
) => {
  try {
    const res = await api.delete(`/financeAccount/deleteBudgetComponent`, {
      params: { uid_plano_orcamentario_componente },
    });

    return res.data;
  } catch (error: any) {
    handleCatch(error);
  }
};

export const postComponentBudget = async ({
  nome,
  natureza,
  observacao,
  status,
  tipo_vinculo,
  uid_tipo,
}: {
  nome?: string;
  natureza?: string;
  observacao?: string;
  status?: number;
  tipo_vinculo?: "rh_fixo" | "rh_variavel" | "outros_financeiro" | "";
  uid_tipo?: string;
}) => {
  try {
    const response = await api.post(`/financeAccount/postComponentBudget`, {
      nome,
      natureza,
      observacao,
      status,
      tipo_vinculo,
      uid_tipo,
    });

    return response.data;
  } catch (error: any) {
    handleCatch(error);
  }
};

export const patchComponentBudget = async ({
  nome,
  natureza,
  observacao,
  status,
  uid_plano_orcamentario_componente,
  uid_plano_orcamentario_vinculo,
  tipo_vinculo,
  uid_tipo,
}: {
  nome?: string;
  natureza?: string;
  observacao?: string;
  status?: number;
  uid_plano_orcamentario_componente?: string;
  uid_plano_orcamentario_vinculo?: string;
  tipo_vinculo?: "rh_fixo" | "rh_variavel" | "outros_financeiro" | "";
  uid_tipo?: string;
}) => {
  try {
    const response = await api.patch(`/financeAccount/patchComponentBudget`, {
      nome,
      natureza,
      observacao,
      status,
      uid_plano_orcamentario_componente,
      tipo_vinculo,
      uid_tipo,
      uid_plano_orcamentario_vinculo,
    });

    return response.data;
  } catch (error: any) {
    handleCatch(error);
  }
};

export const getCustType = async (
  type: "rh_fixo" | "rh_variavel" | "outros_financeiro" | "",
) => {
  try {
    const response = await api.get(`/financeAccount/getCustType`, {
      params: { type },
    });

    return response.data.data;
  } catch (error: any) {
    handleCatch(error);
  }
};
